import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const advisorKeys = {
  all: ['advisors'],
  list: (page, searchParams, hodId) => [...advisorKeys.all, 'list', page, searchParams, hodId],
};

export const useAdvisors = (page = 1, searchParams = {}, hodId = null) => {
  return useQuery({
    queryKey: advisorKeys.list(page, searchParams, hodId),
    queryFn: async () => {
      // Fetch the legal advisors with search parameters
      const response = await userService.getlegalAdvisors(page, searchParams);
      
      // Determine if the response is for admin or HOD
      const isAdminResponse = response.data && response.data.pagination;
      const users = isAdminResponse ? response.data.users : response.data;
      const pagination = isAdminResponse ? response.data.pagination : response.pagination;

      // Filter advisors based on HOD ID if provided
      const filteredAdvisors = hodId
        ? users.filter(user => user.assigned_to?.id === hodId)
        : users;

      // Return both the advisors and pagination data
      return {
        data: filteredAdvisors,
        pagination: {
          current_page: pagination.current_page,
          total: pagination.total,
          per_page: pagination.per_page,
          last_page: pagination.last_page
        }
      };
    },
    keepPreviousData: true // Keep displaying previous data while new data is fetched
  });
}; 